import { createHead } from '@unhead/vue'
import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import i18n from './i18n'
import router from './router'
import { initializeGoogleAnalytics } from './utils/analytics'


// Initialize Google Analytics
initializeGoogleAnalytics()
const head = createHead()

createApp(App)
  .use(head)
  .use(i18n)
  .use(router)
  .mount('#app')